import React, { useState, useEffect } from "react";
import { Accordion, Button, Table, Form } from "react-bootstrap";
import LineCharts from "../../components/Charts/LineCharts";
import "./MeasuringPoints.css";
import { BASE_URL } from "../../config";
import axios from "axios";
import { getAccessToken } from "../LoginForm/Auth/auth";

const MeasuringPoints = ({ selectedFeatures }) => {
    const [expandedTable, setExpandedTable] = useState({});
    const [relatedDataMap, setRelatedDataMap] = useState({});
    const [selectedTableIndex, setSelectedTableIndex] = useState({});
    const [openItems, setOpenItems] = useState({});
    const [parentKey, setParentKey] = useState("0");

    useEffect(() => {
        if (selectedFeatures && selectedFeatures.length > 0) {
            const token = getAccessToken();

            selectedFeatures.forEach((feature) => {
                if (feature?.properties?.eic) {
                    const eic = feature.properties.eic;
                    const wfsUrl = `${BASE_URL}/geoserver/elektro/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=elektro%3Amjerna_mjesta_mjerenja&CQL_FILTER=eic='${eic}'&outputFormat=application%2Fjson`;

                    axios.get(wfsUrl, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then((response) => {
                            const data = response.data;

                            const uniqueData = data.features.filter((item, index, self) =>
                                index === self.findIndex(
                                    (t) => t.properties.obracunski_period === item.properties.obracunski_period
                                )
                            );

                            uniqueData.sort((a, b) => {
                                const periodA = a.properties.obracunski_period.split("-")[0].trim();
                                const periodB = b.properties.obracunski_period.split("-")[0].trim();
                                const dateA = new Date(periodA.split(".").reverse().join("-"));
                                const dateB = new Date(periodB.split(".").reverse().join("-"));
                                return dateA - dateB;
                            });

                            setRelatedDataMap((prev) => {
                                const newData = {
                                    ...prev,
                                    [feature.properties.eic]: uniqueData
                                };

                                setSelectedTableIndex((prevSel) => {
                                    const current = prevSel[feature.properties.eic];
                                    const exists = uniqueData.some(
                                        (item) => item.properties.obracunski_period === current
                                    );
                                    return exists
                                        ? prevSel
                                        : {
                                            ...prevSel,
                                            [feature.properties.eic]: ""
                                        };
                                });

                                return newData;
                            });
                        })
                        .catch((error) => {
                            console.error("Greška pri dohvaćanju podataka:", error.response ? error.response.data : error.message);
                        });
                }
            });
        }
    }, [selectedFeatures]);

    const toggleAccordion = (index) => {
        setOpenItems((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const ReadingSection = ({ relatedData }) => {
        const [selectedPeriod, setSelectedPeriod] = useState("");

        const selectedFeature = relatedData.find(
            (item) => item.properties?.obracunski_period === selectedPeriod
        );

        return (
            <>
                <Form.Group>
                    <Form.Label>Odaberite vremenski period očitanja:</Form.Label>
                    <Form.Select
                        onChange={(e) => setSelectedPeriod(e.target.value)}
                        value={selectedPeriod}
                        className="selectReadings"
                    >
                        <option value="">Izaberite</option>
                        {relatedData.map((item, i) => (
                            <option key={i} value={item.properties?.obracunski_period}>
                                {item.properties?.obracunski_period || `Tabela ${i + 1}`}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                {selectedFeature && (
                    <div className="accordion-item mt-2">
                        <Table striped bordered hover className="feature-info-table">
                            <thead>
                                <tr>
                                    <th>Atribut</th>
                                    <th>Vrednost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(selectedFeature.properties).map(([key, value]) => (
                                    <tr key={key}>
                                        <td className="key-column">{key}</td>
                                        <td className="value-column">{value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </>
        );
    };

    return (
        <div className="measuring-info">
            <Accordion activeKey={parentKey} onSelect={(key) => setParentKey(key === parentKey ? null : key)}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Podaci o mjernim mjestima</Accordion.Header>
                    <Accordion.Body>
                        <Accordion alwaysOpen>
                            {selectedFeatures.map((feature, index) => {
                                const featureId = feature.properties.eic || `feature-${index}`;
                                const relatedData = relatedDataMap[featureId] || [];

                                const primaryData = feature?.properties
                                    ? {
                                        "Naziv potrošača": feature.properties.naziv_mm || "N/A",
                                        "Mjerno mjesto": feature.properties.terenska_jedinica || "N/A",
                                        "EIC": feature.properties.eic || "N/A",
                                        "Adresa MM": feature.properties.adresa || "N/A",
                                        "Datum prijave MM": feature.properties.datum_upisa || "N/A",
                                        "Datum odjave MM": feature.properties.datum_prestanka || "N/A",
                                    }
                                    : {};

                                const fullData = feature?.properties || {};

                                return (
                                    <Accordion.Item eventKey={index.toString()} key={featureId}>
                                        <Accordion.Header onClick={() => toggleAccordion(index)}>
                                            {`EIC - ${feature.properties.eic}`}
                                        </Accordion.Header>
                                        {openItems[index] && (
                                            <Accordion.Body>
                                                <Table striped bordered hover className="feature-info-table">
                                                    <tbody>
                                                        {Object.entries(expandedTable[featureId] ? fullData : primaryData).map(([key, value]) => (
                                                            <tr key={key}>
                                                                <td className="key-column"><strong>{key}</strong></td>
                                                                <td className="value-column">{value}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>

                                                <div style={{ width: "80%", margin: "0 auto" }}>
                                                    <Button
                                                        className="toggle-details-button"
                                                        onClick={() =>
                                                            setExpandedTable((prev) => ({
                                                                ...prev,
                                                                [featureId]: !prev[featureId]
                                                            }))
                                                        }
                                                    >
                                                        {expandedTable[featureId] ? "Sakrij detalje" : "Prikaži više"}
                                                    </Button>
                                                </div>

                                                {relatedData.length > 0 && (
                                                    <LineCharts relatedData={relatedData} />
                                                )}

                                                <div className="latest-readings">
                                                    <h5>POSLEDNJA OČITANJA</h5>
                                                    {relatedData.length > 0 ? (
                                                        <ReadingSection relatedData={relatedData} />
                                                    ) : (
                                                        <p>Nema povezanih podataka za prikaz.</p>
                                                    )}
                                                </div>
                                            </Accordion.Body>
                                        )}
                                    </Accordion.Item>
                                );
                            })}
                        </Accordion>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};

export default MeasuringPoints;
